import styled from 'styled-components';

export const Container = styled.a`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1em 1.25em;
  background-color: var(--gray0);
  border-bottom: 1px solid var(--gray300);
  cursor: pointer;
  color: inherit;
  &:hover {
    color: inherit;
    text-decoration: none;
  }
  &:last-of-type {
    border-bottom: 0;
  }
  i {
    font-size: 2em;
    margin-right: 0.5em;
  }
  .name {
    display: flex;
    flex: 1;
    line-height: 1.5em;
    p {
      margin: 0;
      margin-right: 0.5em;
    }
    .recommended {
      display: block;
      font-size: 0.75em;
      color: var(--pink600);
      font-weight: bold;
      margin-right: 0.5em;
    }
  }
  &:hover {
    background-color: var(--blue100);
  }
`;

export const LeftView = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
`;

export const BadgeView = styled.div`
  font-size: 0.75em;
  color: var(--var600);
  border: 1px solid var(--gray300);
  border-radius: 1.25em;
  padding: 0.25em 0.75em;
`;
